export const EVENTS_RECIEVED = "EVENTS_RECIEVED"
export const EVENTS_SAVED = "EVENTS_SAVED"
export const EVENTS_DELETED = "EVENTS_DELETED"
export const EVENTS_UNLOADED = "EVENTS_UNLOADED"
